import "./alert-group.css.js";
const o = {
  alert: "pf-v6-c-alert",
  alertGroup: "pf-v6-c-alert-group",
  alertGroupItem: "pf-v6-c-alert-group__item",
  alertGroupOverflowButton: "pf-v6-c-alert-group__overflow-button",
  modifiers: {
    toast: "pf-m-toast",
    offstageTop: "pf-m-offstage-top",
    offstageRight: "pf-m-offstage-right"
  }
};
export {
  o as default
};
